<template>
  <div class="moduleStyle_new" :class="`moduleStyle_${listArr.moduleStyle}`">
    <div class="basic_product_detail_wrap">
      <div class="basic_product_detail_header">
        <div class="basic_product_detail_left_content">
          <div class="banner_child">
            <swiper
              ref="mySwiper"
              class="basic_product_detail_swiper list_box"
              :options="swiperOption"
              v-if="showPcSwiper">
              <swiper-slide v-for="(item, index) in album" :key="index" class="slide-list">
                <div class="detail_big_pic_content">
                  <template v-if="has_video && index === 0">
                    <video :muted="true" :src="productInfo.video_url" controls="controls"
                           class="position_center_middle video_view" :poster="item"></video>
                  </template>
                  <img v-else :src="item" class="position_center_middle" @click="imgUpdate(index)"/>
                </div>
              </swiper-slide>
            </swiper>
            <template v-if="$store.state.app.view_pattern === 'pc' && album.length > 1">
              <div class="arrow prev" @click="swiper_prev"></div>
              <div class="arrow next" @click="swiper_next"></div>
            </template>
          </div>
        </div>
        <div class="basic_product_detail_right_content">
          <div class="detail_title_wrap">
            <span class="detail_main_title">{{ productTitle }}</span>
            <div class="detail_func_wrap" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile'">
              <div class="detail_share" v-if="$store.state.app.language === 'zh-cn'">
                <my_share_render title="" :share-type="pc_widgets_infor.shareType"
                                 v-if="pc_widgets_infor.share === 'open'"></my_share_render>
              </div>
              <div class="detail_share" v-if="$store.state.app.language !== 'zh-cn'">
                <my_share_render title="" :share-type="pc_widgets_infor.enShareType"
                                 v-if="pc_widgets_infor.share === 'open'"></my_share_render>
              </div>
            </div>
          </div>
          <cart v-if="has_cart">
            <template><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
          </cart>

          <div class="detail_other_message" v-if="(productParams.length > 0 ||
            (productInfo.custom_attr && productInfo.custom_attr.length > 0))">
            <div class="detail_other" v-for="item in productParams" :key="item.id">
              <span class="detail_title">{{ item.title }}：</span>
              <span class="detail_value">{{ item.value }}</span>
            </div>
            <!-- 自定义的属性显示 -->
            <template v-if="false && productInfo.custom_attr && productInfo.custom_attr.length > 0">
              <div class="detail_other" v-for="(custom, index) in productInfo.custom_attr" :key="index">
                <span class="detail_title">{{ custom.attr_name }}：</span>
                <span class="detail_value">{{ custom.attr_value }}</span>
              </div>
            </template>
          </div>
          <template v-if="!has_cart"><product_button_wrap :module="module" :productInfo="productInfo"></product_button_wrap></template>
          <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
            <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
              v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
            <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
              v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
          </div>
        </div>
      </div>
    </div>
    <div class="detail_content detail-summary-content"
         v-if="productParams.length > 0 || (productInfo.custom_attr &&  productInfo.custom_attr.length > 0)" v-html="productInfo.summary">
    </div>
  </div>

</template>

<script>
import i18n from '../../../language/index'


import product_button_wrap from "./product_button_wrap";
import cart from './cart'
import params from './params'
export default {
  name: 'one_img',
  data() {
    return {
      swiperOption: {
        myVm: this,
        loop: true,
        autoplay: true,
        speed: 500,
        direction: "horizontal",
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        observeParents: true
      },
      showPcSwiper: true
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    productInfo: {
      type: Object,
      default: null
    },
    productTitle: {
      type: String,
      default: ''
    },
    album: {
      type: Array,
      default: null
    },
    showImgIndex: {
      type: Number,
      default: 0
    },
    productParams: {
      type: Array,
      default: null
    }
  },
  computed: {
    has_cart(){
      return this.$store.state.app.road_type&& this.productInfo.p_5 != 0
    },
    theme_color() {
      return this.$store.state.myRender.common.theme_color
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    has_video() { // 是否存在视频
      return this.productInfo.video_url
    },
    video_update() {
      return this.has_video ? this.album.slice(1) : this.album
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    }
  },
  watch: {
    '$store.state.app.view_pattern'(val) {
      this.$nextTick(() => {
        if (val === 'pc') {
          setTimeout(() => {
            this.showPcSwiper = true
          }, 300)
        } else {
          this.showPcSwiper = false
        }
      })
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    imgUpdate(index) { //点击图片进行放大处理的显示
      this.$parent.img_scale_show = true
      this.$parent.showImgIndex = index
    },
  },
  components:{
    product_button_wrap,
    cart,
    params
  }
}
</script>

<style lang="scss" scoped>
.moduleStyle_new {
  position: relative;
  font-size: 14px;

  .basic_product_detail_wrap {
    width: 100%;
    font-size: 14px;

    .basic_product_detail_header {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;

      .basic_product_detail_left_content {
        width: 100%;
        max-width: 468px;

        .banner_child {
          position: relative;
          max-width: 468px;
          max-height: 468px;

          .arrow {
            cursor: pointer;
            display: block;
            width: 40px;
            height: 40px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
            position: absolute;
            z-index: 99;
            top: 50%;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
            background: rgba(0, 0, 0, 0.2);
            -webkit-transition: background 0.15s;
            -o-transition: background 0.15s;
            -moz-transition: background 0.15s;
            transition: background 0.15s;
            outline: 0;
          }

          .arrow:before {
            content: "";
            position: absolute;
            display: block;
            width: 10px;
            height: 18px;
            background: url("/static/image/backimg1.png") -23px -268px;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%) translateY(-50%);
            -moz-transform: translate(-50%) translateY(-50%);
            -ms-transform: translate(-50%) translateY(-50%);
            -o-transform: translate(-50%) translateY(-50%);
            transform: translate(-50%) translateY(-50%);
          }

          .prev {
            left: 0;
          }

          .next {
            right: 0;
          }

          .next:before {
            background-position-x: -53px;
            left: 54%;
          }

          .detail_big_pic_content {
            border: 1px solid #eee;
            position: relative;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 100%;
            padding-bottom: 100%;

            .position_center_middle {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
            }
          }
        }
      }

      .basic_product_detail_right_content {
        box-sizing: border-box;

        .detail_title_wrap {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2px;

          .detail_main_title {
            color: #333;
            font-size: 20px;
            overflow: hidden;
            min-width: 0;
            height: 40px;
            line-height: 40px;
            display: inline-block;
            padding-right: 20px;
          }

          .detail_func_wrap {
            min-width: 80px;
            text-align: right;
            flex-shrink: 0;

            .detail_share {
              display: inline-block;
              font-size: 14px;
              color: #333;
              vertical-align: middle;
              cursor: pointer;

              /deep/ .g-share-render-box {
                .jz_share_text {
                  .u-icon {
                    display: block;
                    width: 40px;
                    height: 35px;
                    line-height: 35px;
                    font-size: 24px;
                    text-align: center;
                    margin: 0 !important;
                  }

                  .u-share_title {
                    display: none;
                  }
                }

                .jz_share_list {
                  right: auto;
                  left: -30px;
                  text-align: center;

                  &::before {
                    right: auto;
                    left: 45px;
                  }
                }
              }
            }
          }
        }

        .detail_share_tile {
          margin: 10px 0px;
        }

        .detail_other_message {
          margin-left: 0px;
          margin-top: 6px;
          transition: margin-left 0.5s;

          .detail_other {
            border-bottom: none !important;
            line-height: 40px;
            overflow: hidden;
            height: 40px;
            display: block;

            .detail_title {
              font-size: 16px;
              color: #333;
            }

            .detail_value {
              font-size: 16px;
              color: #333;
              opacity: 0.9;
            }
          }
        }

        /deep/ .product_button_wrap {
          align-items: center;
          margin-top: 10px;

          .product_advisory_btn {
            width: auto;
            min-width: 150px;
            height: 42px;
            color: #fff;
            font-size: 15px;
            line-height: 42px;
            text-align: center;
            border-radius: 21px;
            background-color: var(--theme_color);
            transition: background-color .3s;
            padding: 0px 18px;
            .icon-phonenew {
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  .detail_content {
    margin-top: 6px;
    padding: 10px 10px 10px 0;
  }
}

.moduleStyle_6 .basic_product_detail_right_content {
  margin-right: 100px;
  flex: 1;
}

.moduleStyle_5 .basic_product_detail_left_content {
  margin-right: 100px;
}

.moduleStyle_5 .basic_product_detail_right_content {
  flex: 1;
}

.moduleStyle_6 .basic_product_detail_header {
  flex-direction: row-reverse;
  flex-wrap: wrap-reverse !important;
}

.product_advisory_email span {
  max-width: 100%;
  white-space: nowrap;
  vertical-align: middle;
}

.product_advisory_email i {
  font-size: 18px;
}

.view_pattern_pc .product_advisory_email {
  width: auto;
  max-width: 100%;
  padding: 0 15px;
  height: 42px;
  color: #fff;
  font-size: 15px;
  line-height: 42px;
  text-align: center;
  border-radius: 21px;
  background-color: var(--theme_color);
  transition: background-color .3s;
  align-items: center;
  justify-content: center;
}

.product_advisory_btn, .product_advisory_email {
  margin-right: 10px;
}

.view_pattern_pc /deep/ .product_button_wrap {
  display: block;

  .product_advisory_btn, .product_advisory_email {
    display: inline-block;
    margin-bottom: 10px;
    vertical-align: top;
  }
}

.view_pattern_mb {
  /deep/ .product_button_wrap {
    display: flex;
  }
}

.view_pattern_pc {
  .product_advisory_email {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_product_detail/components/one_img.vue